/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

import { colors } from "@dotnet/telematics-design-system";

import RectangleLoader from "./RectangleLoader";

interface HeaderTitleLoaderProps {
  dashboardPage?: boolean;
}

const HeaderTitleLoader = ({ dashboardPage }: HeaderTitleLoaderProps) => {
  return (
    <div css={css({ display: "flex" })} data-testid="header-title-loader">
      <RectangleLoader
        width={216}
        borderRadius={"46px"}
        backgroundColor={colors.gray200}
        height={24}
        customStyle={{ marginRight: "22px" }}
      />
      {!dashboardPage && (
        <RectangleLoader
          width={38}
          borderRadius={"46px"}
          backgroundColor={colors.gray200}
          height={24}
        />
      )}
    </div>
  );
};

export default HeaderTitleLoader;
